import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[repHtmlTag]'
})
export class htmlTagDirective {
    
    constructor(private _el: ElementRef, private _control: NgControl) { }

    @HostListener("input", ["$event"]) onInputChange(event) {
        const initalValue = this._el.nativeElement.value;
        this._control.control.setValue(initalValue.replace(
            /[^A-Za-z0-9!@#$%^&*()\\`+,\|{}?\.\ _\-]*/g,
            ""
        )); /*Not allow special charcter is - ;":/=  That's it*/
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    }

}
